import { isCurrencyShouldBeInteger } from "./utils";

export const isAllInputValid = (...args) => {
  let allInputIsValid = true;
  for (const arg of args) {
    if (arg) {
      allInputIsValid = false;
      return allInputIsValid;
    }
  }
  return allInputIsValid;
};

export const amountValidation = (currency, value) => {
  let isValid = false;
  let regex;
  if (currency && isCurrencyShouldBeInteger(currency)) {
    regex = /^\d*(,\d{3})*$/g;
  } else {
    regex = /^\d*(,\d{3})*(\.\d{1,2}){0,1}$/g;
  }
  if (!value || regex.test(value.toString())) {
    isValid = true;
  }
  return isValid;
};

export const emailFormatValidator = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export const phoneFormatValidator = (phone) => {
  return /^[2-9][0-9]{7}$/.test(phone);
};

export const percentageFormatValidator = (value) => {
  if (value === "" || value == null) return true;
  const num = parseFloat(value);
  return !isNaN(num) && num >= 0 && num <= 100;
};

export const searchErrorHandler = (searchFieldInput, errorCatchers = []) => {
  const errorObj = Object.assign(
    {},
    ...errorCatchers.map((catcher) => catcher(searchFieldInput) ?? {}),
  );
  return { errorObj, hasError: Object.values(errorObj).some((e) => e) };
};
